export default {
  title: {
    ar: '.هذا هو الجواب الصحيح',
    en: 'That’s the correct answer.'
  },

  next: {
    ar: 'السؤال التالي',
    en: 'Next question'
  },

  complete: {
    ar: 'شاهد نتيجتك',
    en: 'Complete the Quiz'
  }
};
